/**
 * LocalStorage utilities for form data persistence
 */

const FORM_DATA_KEY = 'visa_application_draft';

export interface FormDraft {
    step: string;
    data: Record<string, unknown>;
    lastSaved: string;
    userId: number;
}

export const saveFormDraft = (draft: FormDraft): void => {
    try {
        localStorage.setItem(FORM_DATA_KEY, JSON.stringify(draft));
    } catch (error) {
        console.error('Error saving form draft:', error);
    }
};

export const getFormDraft = (): FormDraft | null => {
    try {
        const draft = localStorage.getItem(FORM_DATA_KEY);
        return draft ? JSON.parse(draft) : null;
    } catch (error) {
        console.error('Error reading form draft:', error);
        return null;
    }
};

export const clearFormDraft = (): void => {
    try {
        localStorage.removeItem(FORM_DATA_KEY);
    } catch (error) {
        console.error('Error clearing form draft:', error);
    }
};

export const updateFormDraft = (
    step: string,
    data: Record<string, unknown>,
    userId: number
): void => {
    const draft: FormDraft = {
        step,
        data,
        lastSaved: new Date().toISOString(),
        userId,
    };
    saveFormDraft(draft);
};
